// Dashboard.js
import React, { useState, useEffect } from 'react';
import DailySale from '../component/WeeklySale';
import OrderList from './orderHistory/OrderList';
import { getDailySalesApi, getTotalCountsApi } from '../../Apis/Api';
import WeeklySaleChart from './WeeklySaleChart';

const Dashboard = () => {
  const [totalProducts, setTotalProducts] = useState(0);
  const [totalCategories, setTotalCategories] = useState(0);
  const [totalSubcategories, setTotalSubcategories] = useState(0);
  const [dailySales, setDailySales] = useState(null);
  const [loading, setLoading] = useState({
    counts: true,
    sales: true
  });
  const [error, setError] = useState({
    counts: null,
    sales: null
  });

  useEffect(() => {
    // Fetch total counts
    getTotalCountsApi()
      .then((response) => {
        setTotalProducts(response.data.data.totalProducts);
        setTotalCategories(response.data.data.totalCategories);
        setTotalSubcategories(response.data.data.totalSubCategories);
        setLoading(prev => ({ ...prev, counts: false }));
      })
      .catch((err) => {
        setError(prev => ({ ...prev, counts: err.message }));
        setLoading(prev => ({ ...prev, counts: false }));
      });

    // Fetch daily sales
    getDailySalesApi()
      .then((response) => {
        setDailySales(response.data.data);
        setLoading(prev => ({ ...prev, sales: false }));
      })
      .catch((err) => {
        setError(prev => ({ ...prev, sales: err.message }));
        setLoading(prev => ({ ...prev, sales: false }));
      });
  }, []);

  return (
    <div className="p-6 min-h-screen">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Dashboard</h1>
      
      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <div className="bg-white shadow-lg rounded-lg p-6 hover:shadow-xl transition-shadow duration-300">
          <h2 className="text-lg font-medium text-gray-600">Total Products</h2>
          {loading.counts ? (
            <div className="animate-pulse h-10 w-20 bg-gray-200 rounded mt-2"></div>
          ) : error.counts ? (
            <p className="text-red-500">Error loading data</p>
          ) : (
            <h1 className="text-4xl font-extrabold text-gray-800 mt-2">{totalProducts}</h1>
          )}
        </div>

        <div className="bg-white shadow-lg rounded-lg p-6 hover:shadow-xl transition-shadow duration-300">
          <h2 className="text-lg font-medium text-gray-600">Total Categories</h2>
          {loading.counts ? (
            <div className="animate-pulse h-10 w-20 bg-gray-200 rounded mt-2"></div>
          ) : error.counts ? (
            <p className="text-red-500">Error loading data</p>
          ) : (
            <h1 className="text-4xl font-extrabold text-gray-800 mt-2">{totalCategories}</h1>
          )}
        </div>

        <div className="bg-white shadow-lg rounded-lg p-6 hover:shadow-xl transition-shadow duration-300">
          <h2 className="text-lg font-medium text-gray-600">Total SubCategories</h2>
          {loading.counts ? (
            <div className="animate-pulse h-10 w-20 bg-gray-200 rounded mt-2"></div>
          ) : error.counts ? (
            <p className="text-red-500">Error loading data</p>
          ) : (
            <h1 className="text-4xl font-extrabold text-gray-800 mt-2">{totalSubcategories}</h1>
          )}
        </div>
      </div>

      {/* Charts Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
        <div className="bg-white p-4 rounded-lg shadow-lg">
          <h2 className="text-xl font-semibold mb-4">Daily Sales</h2>
          {loading.sales ? (
            <div className="flex justify-center items-center h-64">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
            </div>
          ) : error.sales ? (
            <div className="text-red-500 p-4">Error loading daily sales: {error.sales}</div>
          ) : (
            <DailySale dailySalesData={dailySales || { onlineSales: 0, offlineSales: 0, totalDailySales: 0 }} />
          )}
        </div>
        {/* <div className="bg-white p-4 rounded-lg shadow-lg">
          <h2 className="text-xl font-semibold mb-4">Weekly Sales by Category</h2>
          <WeeklySaleChart />
        </div> */}
      </div>

      {/* Order List */}
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-xl font-semibold mb-4 text-gray-800">Delivery Status</h2>
        <OrderList />
      </div>
    </div>
  );
};

export default Dashboard;